// extracted by mini-css-extract-plugin
module.exports = {"content":"we"};